import { Button } from '@components/button';
import { useOutsideClick } from '@hooks/useOutsideClick';
import { SelectContainer, SelectOption, SelectOptions } from '@components/button-select/ButtonSelect.style';
import { useRef, useState } from 'react';

export interface ButtonSelectOption<T> {
    value: T;
    label: string;
    disabled?: boolean;
}

interface ButtonSelectProps<T> {
    title: string;
    type?: 'primary' | 'secondary' | 'inverted' | 'tertiary' | 'quaternary' | undefined;
    size?: 'small' | 'large';
    icon?: (props: object) => JSX.Element;
    disabled?: boolean;
    placement?: 'leftBottom' | 'centerBottom' | 'rightBottom';
    options: ButtonSelectOption<T>[];
    onOption: (opt: ButtonSelectOption<T>) => void;
    onClickClose?: boolean;
}

export function ButtonSelect<T>({
    title,
    type,
    size,
    icon,
    disabled = false,
    placement,
    options,
    onOption,
    onClickClose = true,
}: ButtonSelectProps<T>) {
    const [show, setShow] = useState(false);
    const targetRef = useRef<HTMLDivElement>(null);
    useOutsideClick(targetRef, () => setShow(false));

    const clickHandler = (opt: ButtonSelectOption<T>) => {
        if (!opt.disabled) {
            onOption(opt);
            if (onClickClose) {
                setShow(false);
            }
        }
    };
    return (
        <div ref={targetRef}>
            <SelectContainer>
                <Button
                    $size={size}
                    $type={type}
                    title={title}
                    disabled={disabled}
                    icon={icon}
                    onClick={() => setShow(!show)}
                />
                {show && (
                    <SelectOptions $placement={placement}>
                        {options.map((option, idx) => {
                            return (
                                <SelectOption
                                    onClick={() => clickHandler(option)}
                                    key={`option-${idx}`}
                                    $disabled={option.disabled || false}
                                >
                                    {option.label}
                                </SelectOption>
                            );
                        })}
                    </SelectOptions>
                )}
            </SelectContainer>
        </div>
    );
}
